import { render, staticRenderFns } from "./ThumbnailMoldes.vue?vue&type=template&id=1fc04e32&"
import script from "./ThumbnailMoldes.vue?vue&type=script&lang=js&"
export * from "./ThumbnailMoldes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports